import CountertopCommon from "../countertopCommon";
import {LayoutAbbreviations} from "../../constants";

export default class Countertop extends CountertopCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'center_island_countertop';
    this.dbName = 'Center Island Countertop';
    this.partName = 'Island Countertop';
    this.homePageTitle = 'Center Island Countertop';
    this.translateId = "visualizer.kitchen.center_island.center_island_countertop";
    this.isStoneFeature = true;
    this.toggleSwitchedOffByUser = false;  // is used for returning toggle back when feature is found
    this.hasAdditionalParts = false;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    if (!this.disabled && centerIslandParent.cabinet.disabled) {
      centerIslandParent.cabinet.disabled = false;
      centerIslandParent.cabinet.disabledClick();
    }
  }

  load(dbFeature) {
    this.fixEdgeMeta(dbFeature);
    if (dbFeature.metaData["Part"]) {
      const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
      return super.load_(dbFeature, new Countertop(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return super.load_(dbFeature, new Countertop())
  }

  setLayers(layout) {

    const cabinet = this.getParent().cabinet;
    if (cabinet && (cabinet.disabled || !cabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    return super.setLayers(layout);
  }

  canUseNavigationFilterSteps() {
    const parent = this.getParent();
    return parent.edge // display filters only if edges exist
  }

  canUseNavigationFilter() {
    return true //TODO[Artem] add here features filters check
  }

}
